import { useShareGraphicMutation } from 'api/overview';
import { Button } from 'components/ui/Button';
import { Popup } from 'components/ui/Popup';
import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { embedQuizType, openWindow, replacePlaceholder, wait } from 'utils/commonFunctions';
import {
  FACEBOOK_SHARE_URL,
  QUIZ_ARENA_BASE_URL,
  QUIZ_TYPE_TOPICAL,
  SHARE_TYPES,
  SOCIAL_SHARING_MESSAGE,
  SOCIAL_SHARING_TOPICAL_MESSAGE,
  TWITTER_SHARE_URL
} from 'utils/constants';

const InviteFriendsPopup = ({ handleClose, ...porps }) => {
  const { state } = useLocation();

  const [buttonText, setButtonText] = useState('Close');

  const [share] = useShareGraphicMutation();

  const initializeSharables = async () => {
    const data = await share({
      quizId: state?.quizId,
      payload: { gamedayId: state?.GamedayId, attemptId: state?.AttemptId }
    }).unwrap();

    const url = data?.Data?.MetaPath;

    const facebook = () => {
      openWindow(
        replacePlaceholder(FACEBOOK_SHARE_URL, {
          // QUIZ_REDIRECT_URL: encodeURIComponent(QUIZ_ARENA_BASE_URL)
          QUIZ_REDIRECT_URL: url
        })
      );
    };

    const twitter = () => {
      openWindow(
        replacePlaceholder(TWITTER_SHARE_URL, {
          MESSAGE:
            embedQuizType() === QUIZ_TYPE_TOPICAL
              ? SOCIAL_SHARING_TOPICAL_MESSAGE
              : SOCIAL_SHARING_MESSAGE,
          // QUIZ_REDIRECT_URL: encodeURIComponent(QUIZ_ARENA_BASE_URL),
          QUIZ_REDIRECT_URL: url,
          HASHTAGS: ''
        }),
        400
      );
    };

    const copy = async () => {
      // navigator.clipboard.writeText(QUIZ_ARENA_BASE_URL);
      navigator.clipboard.writeText(url);
      setButtonText('Copied to clipboard');

      await wait(2000);

      setButtonText('Close');
    };

    return {
      facebook,
      twitter,
      copy
    };
  };

  // const sharables = data && initializeSharables(data.htmlUrl);

  return (
    <Popup {...porps}>
      <Popup.Body>
        <div className='si-popup__img'>
          <img src={require('assets/images/invite.png')} />
        </div>
        <Popup.Heading>Thanks for playing!</Popup.Heading>
        <Popup.Desc>Invite your friends to have a go.</Popup.Desc>

        <div className='si-share__med'>
          {SHARE_TYPES.map((item, index) => (
            <div
              className='si-share__item'
              key={index}
              onClick={async () => {
                const fn = await initializeSharables();
                fn[item.shareFn]();
              }}
            >
              <i className={item.icon}></i>
            </div>
          ))}
        </div>
        <div className='si-btn__wrap'>
          <Button onClick={handleClose}>{buttonText}</Button>
        </div>
      </Popup.Body>
    </Popup>
  );
};

export { InviteFriendsPopup };
